import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M9.328 3.743a.5.5 0 0 0-.707 0L4.387 7.977a.744.744 0 0 0-.22.52v2.45a.743.743 0 0 0 .46.65.637.637 0 0 0 .28.06h.01l2.4-.01a.739.739 0 0 0 .53-.21l4.234-4.234a.5.5 0 0 0 0-.707L9.328 3.743ZM13.506 5.07c.193.198.515.2.666-.033a2.457 2.457 0 0 0-.315-3.07 2.445 2.445 0 0 0-2.963-.373c-.226.133-.252.432-.078.629.66.75 2.011 2.152 2.69 2.847ZM14.85 13.97a.743.743 0 0 1-.75.75H1.847a.75.75 0 0 1 0-1.5H14.1a.75.75 0 0 1 .747.747l.003.003Z';
const draw24px =
  'M11.323 5.737a1 1 0 0 0-1.412-.002L3.41 12.2a.75.75 0 0 0-.22.53v3.57c0 .199.08.39.22.53l.11.09.13.07a.64.64 0 0 0 .28.06h3.58a.75.75 0 0 0 .49-.23l6.492-6.5a1 1 0 0 0 0-1.414l-3.169-3.169ZM16.344 7.93a.379.379 0 0 0 .536 0 .58.58 0 0 0 .1-.12A3.24 3.24 0 0 0 17 3.28a3.33 3.33 0 0 0-4.62 0 .484.484 0 0 0-.001.685l3.965 3.965ZM20.76 21.49H3.24a.75.75 0 1 1 0-1.5h17.52a.75.75 0 1 1 0 1.5Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const PencilLineFilledIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>(generateRenderedIcon(icons, 'pencilLineFilled')) as IconWithRender;

PencilLineFilledIcon.displayName = 'PencilLineFilledIcon';
PencilLineFilledIcon.propTypes = Icon.propTypes;
PencilLineFilledIcon.renderIcon = (props) => (
  <PencilLineFilledIcon {...props} />
);
export default PencilLineFilledIcon;
